import * as tslib_1 from "tslib";
import 'core-js/features/object/assign';
import hyperscript from 'mithril';
import { extractChildren } from './util/children';
var mithrilStatic = tslib_1.__assign({}, hyperscript);
var isPlainFunction = function (input) {
    return typeof input === 'function' && typeof input.prototype.view !== 'function';
};
export var m = Object.assign(function (selector, attrs) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    var makeChildren = function (children) {
        return !children || children.length === 0
            ? {}
            : { children: extractChildren(children) };
    };
    if (isPlainFunction(selector)) {
        if (attrs &&
            (typeof attrs !== 'object' || attrs.tag != null || Array.isArray(attrs)))
            return selector(makeChildren([].concat(attrs).concat(children)));
        return selector(tslib_1.__assign({}, attrs, makeChildren(children)));
    }
    if (typeof selector === 'string' &&
        attrs &&
        !Array.isArray(attrs) &&
        typeof attrs === 'object' &&
        !attrs.tag) {
        var childrenAttr = attrs.children, rest = tslib_1.__rest(attrs, ["children"]);
        return hyperscript.apply(void 0, [selector, rest, childrenAttr].concat(children));
    }
    return hyperscript.apply(void 0, [selector, attrs].concat(children));
}, hyperscript);
